var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"}})}
var staticRenderFns = []

export { render, staticRenderFns }